export const leaksShowAttrStyles = {
  containerStyles: {},
  titleStyles: { minWidth: '300px' },
  valueStyles: {},
  buttonStyles: {
    width: '10%',
  },
};
